// Model credit calculation rules.
// Currently supports: seedance, wan-2-5 (others can be added later).

export const MODEL_CREDIT_RULES = {
  'kling-2-5': {
    modelId: 'kling-2-5',
    // Kling 2.5 pricing rules:
    // 5s=30, 10s=60
    calc: function(p) {
      var durationSec = Number(p && p.durationSec) || 5
      if (durationSec === 10) return 60
      return 30
    }
  }
  ,
  'wan-2-2': {
    modelId: 'wan-2-2',
    // Wan 2.2 pricing rules:
    // 480p=25, 1080p=50
    calc: function(p) {
      var res = String((p && p.resolutionKey) || '480p').toLowerCase()
      if (res === '1080p') return 50
      return 25
    }
  }
  ,
  'hailuo-2-3': {
    modelId: 'hailuo-2-3',
    // Hailuo 2.3 pricing rules:
    // 768p: 6s=40, 10s=80
    // 1080p: 6s=80, 10s=160
    calc: function(p) {
      var durationSec = Number(p && p.durationSec) || 6
      var res = String((p && p.resolutionKey) || '768p').toLowerCase()
      var is1080 = (res === '1080p')
      if (durationSec === 10) return is1080 ? 160 : 80
      return is1080 ? 80 : 40
    }
  }
  ,
  runway: {
    modelId: 'runway',
    // Runway pricing rules:
    // 5s=15, 10s=30
    calc: function(p) {
      var durationSec = Number(p && p.durationSec) || 5
      if (durationSec === 10) return 30
      return 15
    }
  }
  ,
  seedance: {
    modelId: 'seedance',
    // Seedance pricing rules:
    // 480p + audio off: 4s => 8, +/-1s => +/-2
    // 480p + audio on : 4s => 16, +/-1s => +/-4
    // 720p + audio off: 4s => 24, +/-1s => +/-6
    // 720p + audio on : 4s => 32, +/-1s => +/-8
    calc: function(p) {
      var durationSec = Number(p && p.durationSec)
      if (!durationSec || isNaN(durationSec)) durationSec = 4
      var res = String((p && p.resolutionKey) || '480p')
      var audioOn = !!(p && p.audioOn)

      var base = 8
      var deltaPerSec = 2

      if (res === '720p') {
        base = audioOn ? 32 : 24
        deltaPerSec = audioOn ? 8 : 6
      } else {
        base = audioOn ? 16 : 8
        deltaPerSec = audioOn ? 4 : 2
      }

      var credits = base + (durationSec - 4) * deltaPerSec
      return credits < 0 ? 0 : credits
    }
  }
  ,
  'wan-2-5': {
    modelId: 'wan-2-5',
    // Wan25 pricing rules:
    // 5s fixed:
    // 480p=30, 720p=60, 1080p=90
    calc: function(p) {
      var res = String((p && p.resolutionKey) || '480p')

      if (res === '720p') return 60
      if (res === '1080p') return 90
      return 30
    }
  }
  ,
  'wan-2-6': {
    modelId: 'wan-2-6',
    // Wan26 pricing rules:
    // 720p: 5s=75, 10s=150, 15s=225
    // 1080p: 5s=100, 10s=200, 15s=300
    calc: function(p) {
      var durationSec = Number(p && p.durationSec) || 5
      var res = String((p && p.resolutionKey) || '720p')

      var base5 = res === '1080p' ? 100 : 75
      var factor = durationSec / 5
      var credits = base5 * factor
      return credits < 0 ? 0 : credits
    }
  }
  ,
  'veo-3-0': {
    modelId: 'veo-3-0',
    // Veo 3.0 pricing rules (integer-only):
    // 720p: 4s=8, 6s=12, 8s=16
    // 1080p: 4s=16, 6s=24, 8s=30
    calc: function(p) {
      var durationSec = Number(p && p.durationSec) || 4
      var res = String((p && p.resolutionKey) || '720p').toLowerCase() // 720p | 1080p | 4k
      var table = {
        '720p': { 4: 8, 6: 12, 8: 16 },
        '1080p': { 4: 16, 6: 24, 8: 30 }
      }

      var row = table[res] || table['720p']
      if (row[durationSec] != null) return row[durationSec]
      return row[4]
    }
  }
  ,
  'veo-3-1': {
    modelId: 'veo-3-1',
    // Veo 3.1 pricing rules:
    // Fast:
    // 720p: 4s=8, 6s=11, 8s=15
    // 1080p: 4s=15, 6s=23, 8s=30
    // 4k: 4s=30, 6s=45, 8s=60
    // Quality = Fast * 5
    calc: function(p) {
      var durationSec = Number(p && p.durationSec) || 4
      var res = String((p && p.resolutionKey) || '720p').toLowerCase() // 720p | 1080p | 4k
      var genType = String((p && p.genType) || 'fast').toLowerCase() // fast | quality
      var fastTable = {
        '720p': { 4: 8, 6: 11, 8: 15 },
        '1080p': { 4: 15, 6: 23, 8: 30 },
        '4k': { 4: 30, 6: 45, 8: 60 }
      }

      var row = fastTable[res] || fastTable['720p']
      var fastCredits = row[durationSec] != null ? row[durationSec] : row[4]
      if (genType === 'quality') return fastCredits * 5
      return fastCredits
    }
  }
  ,
  'kling-2-6': {
    modelId: 'kling-2-6',
    // Kling 2.6 pricing rules:
    // no audio: 5s=28, 10s=55
    // with audio: 5s=55, 10s=110
    calc: function(p) {
      var durationSec = Number(p && p.durationSec) || 5
      var audioOn = !!(p && p.audioOn)
      if (audioOn) {
        if (durationSec === 10) return 110
        return 55
      }
      if (durationSec === 10) return 55
      return 28
    }
  }
  ,
  'kling-3': {
    modelId: 'kling-3',
    // Kling v3 pricing rules:
    // no audio: 5s=28, 10s=55
    // with audio: 5s=55, 10s=110
    calc: function(p) {
      var durationSec = Number(p && p.durationSec) || 5
      var audioOn = !!(p && p.audioOn)
      if (audioOn) {
        if (durationSec === 10) return 110
        return 55
      }
      if (durationSec === 10) return 55
      return 28
    }
  }
  ,
  'sora-2': {
    modelId: 'sora-2',
    // Sora2 pricing rules:
    // 4s=40, 8s=80, 12s=120
    calc: function(p) {
      var durationSec = Number(p && p.durationSec) || 4
      if (durationSec === 8) return 80
      if (durationSec === 12) return 120
      return 40
    }
  }
  ,
  'wan-animate': {
    modelId: 'wan-animate',
    // 标准 wan-std / 专业 wan-pro（与 parameters.mode 对应）
    calc: function (p) {
      return (p && p.animateParamMode) === 'pro' ? 40 : 20
    }
  }
  ,
  'vidu-q3-pro': {
    modelId: 'vidu-q3-pro',
    // Vidu Q3 Pro：按时长 × 分辨率阶梯计费（可随运营调整）
    calc: function(p) {
      var len = Number(p && p.durationSec)
      if (!len || isNaN(len)) len = 5
      len = Math.min(16, Math.max(1, Math.floor(len)))
      var res = String((p && p.resolutionKey) || '720p').toLowerCase()
      var perSec = { '540p': 5, '720p': 8, '1080p': 12 }
      var rate = perSec[res] != null ? perSec[res] : perSec['720p']
      var base = len * rate
      var audioOn = p && p.audioOn !== false
      return audioOn ? Math.max(10, base) : Math.max(8, Math.floor(base * 0.85))
    }
  }
  ,
  pollodance: {
    modelId: 'pollodance',
    calc: function (p) {
      var len = Number(p && p.durationSec)
      if (!len || isNaN(len)) len = 10
      len = Math.min(15, Math.max(4, Math.floor(len)))
      var res = String((p && p.resolutionKey) || '720p').toLowerCase()
      var multRes = res === '480p' ? 1 : res === '1080p' ? 2 : 1.45
      var pv = String((p && p.pollodanceVariant) || '2-0')
      var multVar = pv.indexOf('fast') !== -1 ? 0.88 : 1
      var credits = Math.ceil(len * 2.8 * multRes * multVar)
      return credits < 15 ? 15 : credits
    }
  }
  ,
  seegen: {
    modelId: 'seegen',
    calc: function (p) {
      var len = Number(p && p.durationSec)
      if (!len || isNaN(len)) len = 5
      len = Math.min(15, Math.max(4, Math.floor(len)))
      var res = String((p && p.resolutionKey) || '720p')
      var mult = { '480p': 1, '720p': 1.4, '1080p': 2.2, '2k': 3.2, '4k': 4.5 }
      var rk = res.toLowerCase()
      var m = mult[rk] != null ? mult[rk] : mult['720p']
      var audioOn = !!(p && p.audioOn)
      var base = len * 2 * m * (audioOn ? 1.2 : 1)
      var credits = Math.ceil(base)
      return credits < 10 ? 10 : credits
    }
  }
  ,
  'nano-banana-2': {
    modelId: 'nano-banana-2',
    // Nano Banana 2 定价：
    // v2.5 模式固定 5 积分
    // v3.1 模式按分辨率：1K=5, 2K=10, 4K=15
    calc: function(p) {
      var genType = p && p.genType
      if (genType === 'v25') return 5
      var size = String((p && p.imageSize) || '1K').toUpperCase()
      if (size === '2K') return 10
      if (size === '4K') return 15
      return 5
    }
  }
}

/**
 * Calculate per-output credits for a model.
 * @param {Object} p
 * @param {string} p.modelId
 * @param {number} p.baseCredits - credits at baseDurationSec with 480p resolution
 * @param {number} p.durationSec - selected duration in seconds
 * @param {string} p.resolutionKey - '480p' | '720p' | '1080p'
 * @returns {number}
 */
export function calcModelCredits(p) {
  if (!p) return 0
  var rule = MODEL_CREDIT_RULES[p.modelId]
  if (!rule) return Number(p.baseCredits) || 0

  if (typeof rule.calc === 'function') {
    return rule.calc(p)
  }

  // baseCredits should come from existing model config (e.g. model.credits for 480p).
  var baseCredits = p.baseCredits != null ? Number(p.baseCredits) : (Number(rule.baseCredits480) || 0)
  var durationSec = Number(p.durationSec) || rule.baseDurationSec
  var resolutionKey = String(p.resolutionKey || rule.baseDurationKey || '480p')

  var deltaSec = durationSec - rule.baseDurationSec
  var credits480 = baseCredits + deltaSec * rule.durationDeltaPerSec

  var factor = rule.resolutionFactors[resolutionKey] != null ? rule.resolutionFactors[resolutionKey] : 1
  // Clamp at 0 to avoid negative credits.
  var credits = credits480 * factor
  return credits < 0 ? 0 : credits
}

